export default __webpack_public_path__ + "static/media/carerIcon.3cf59357.svg";